import type { ComponentProps, ReactElement } from "react";
import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { setIsColumnPickerOpen } from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";
import { selectIsColumnPickerOpen } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";

import { ErrorBoundaryWithLogging } from "../../ErrorBoundaryWithLogging";
import TableColumnsSelection from "../components/TableColumnsSelection/TableColumnsSelection";

type Props = Omit<ComponentProps<typeof TableColumnsSelection>, "isOpen" | "onOpen" | "onClose">;

const ColumnsSelectionContainer = ({ renderSelectionTrigger, ...props }: Props): ReactElement => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsColumnPickerOpen);

    const handleOpen = useCallback(() => {
        dispatch(setIsColumnPickerOpen(true));
    }, []);

    const handleClose = useCallback(() => {
        dispatch(setIsColumnPickerOpen(false));
    }, []);

    return (
        <ErrorBoundaryWithLogging
            fallback={
                <TableColumnsSelection
                    isOpen={false}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    renderSelectionTrigger={renderSelectionTrigger}
                />
            }
        >
            <TableColumnsSelection
                isOpen={isOpen}
                onOpen={handleOpen}
                onClose={handleClose}
                renderSelectionTrigger={renderSelectionTrigger}
                {...props}
            />
        </ErrorBoundaryWithLogging>
    );
};

export default ColumnsSelectionContainer;
